import { ArrowDownTwoMd, ArrowUpTwoMd } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';

export type ChangeIcon = 'ArrowDownTwoMd' | 'ArrowUpTwoMd';

// eslint-disable-next-line @typescript-eslint/no-duplicate-type-constituents
type Icons = typeof ArrowDownTwoMd | typeof ArrowUpTwoMd;

const mapIcons: Record<ChangeIcon, Icons> = {
  ArrowDownTwoMd,
  ArrowUpTwoMd,
};
export const MediaCostChangeIcon: FunctionComponent<{ iconName: ChangeIcon }> = ({ iconName }) => {
  const MappedIcon = mapIcons[iconName];
  return <MappedIcon style={{ width: '17px', height: '17px' }} />;
};
